import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53f29254&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=53f29254&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=53f29254&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f29254",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/drone/src/components/Breadcrumb/index.vue').default,Upload: require('/drone/src/components/Upload/index.vue').default,WxFollowQr: require('/drone/src/components/WxFollowQr.vue').default,ReleaseEditGoodsInfoFastSell: require('/drone/src/components/release/editGoodsInfo/fastSell.vue').default,ReleaseRulePhone: require('/drone/src/components/ReleaseRulePhone/index.vue').default})
